export const vehicleBrandsResource = {
  name: '車輛品牌',
  fields: {
    id: 'ID',
    name: '名稱',
    normalizedName: '標準化名稱',
    translationEn: '名稱（English）',
    translationZhTw: '名稱（繁體中文）',
    translationZhCn: '名稱（简体中文）',
    modelCount: '型號數量',
    createdAt: '建立時間',
    updatedAt: '更新時間',
  },
  sections: {
    translations: '翻譯',
  },
  help: {
    normalizedName: '用於查詢的小寫正規化名稱。建立後無法修改。',
  },
  create: {
    title: '新增車輛品牌',
    subtitle: '新增品牌到型錄。翻譯內容會顯示在手機應用程式的選擇器上。',
  },
  edit: {
    title: '編輯車輛品牌',
  },
  delete: {
    title: '刪除車輛品牌',
    cascadeWarning: '此品牌包含 %{count} 個型號。刪除品牌將同時刪除所有相關型號。是否繼續？',
    noModels: '確定要刪除此品牌嗎？',
  },
  notifications: {
    created: '已建立車輛品牌',
    updated: '已更新車輛品牌',
  },
  errors: {
    duplicate: '此名稱的品牌已存在',
  },
};

export const vehicleBrands = {
  'vehicle-brands': vehicleBrandsResource,
};
